module.exports = __webpack_public_path__ + "img/logo.5bd33c56.png";